export default __webpack_public_path__ + "static/5-0612c398f5991b177cb457b14796e379.jpg";